import { render, staticRenderFns } from "./BarraDeBuscar.vue?vue&type=template&id=2a51afa0&scoped=true&"
import script from "./BarraDeBuscar.vue?vue&type=script&lang=js&"
export * from "./BarraDeBuscar.vue?vue&type=script&lang=js&"
import style0 from "./BarraDeBuscar.vue?vue&type=style&index=0&id=2a51afa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51afa0",
  null
  
)

export default component.exports